import { useEffect, useState } from "react";
import { GET_ALLERGY_GROUP_BY_MOLECULES } from "./queries";
import { useQuery } from "@apollo/react-hooks";

const INITIAL_STATE = {
  data: [],
};

export default function useActions({ isOpen, toggle, selectedItem }) {
  const [state, setState] = useState(INITIAL_STATE);

  const {
    data: { getAllergyGroupByMolecules } = {},
    loading: loadingMolecules,
  } = useQuery(GET_ALLERGY_GROUP_BY_MOLECULES, {
    skip: !isOpen,
    fetchPolicy: "network-only",
    variables: {
      where: {
        allergyGroupId: selectedItem?.allergyGroup?.id,
      },
      relations: ["molecule"],
    },
  });

  useEffect(() => {
    if (getAllergyGroupByMolecules) {
      setState((prev) => ({
        ...prev,
        data: getAllergyGroupByMolecules?.map((item) => item?.molecule) || [],
      }));
    }
  }, [getAllergyGroupByMolecules]);

  return [{ state }, { loadingMolecules }];
}
